import { dataPauseCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPauseCircle = /*#__PURE__*/createIcon(dataPauseCircle)
export default IconPauseCircle
